"use client"

import { ExternalLink } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"

export function MetaAdsCrmAccessStep({
  businessName,
  businessSettingsUrl,
  pageName,
  onConfirmed,
}: {
  businessName: string | null
  businessSettingsUrl: string
  pageName: string
  onConfirmed: () => void
}) {
  return (
    <div className="space-y-4">
      <Alert>
        <AlertTitle>Step 3: Give Versafy Access to Your Leads</AlertTitle>
        <AlertDescription className="space-y-3">
          <p>
            Meta requires this final approval before it will send your Page&apos;s lead
            details to Versafy. Without it, the connection test and real callbacks may fail.
          </p>
          <ol className="list-decimal space-y-2 pl-5">
            <li>
              <span>Open Meta Business Settings</span>
              {businessName ? <> for <strong>{businessName}</strong></> : ""}<span>.</span>
            </li>
            <li>
              <span>Select</span> <strong>{pageName}</strong><span>, then open</span>
              <strong> Integrations → Leads Access → CRMs</strong><span>.</span>
            </li>
            <li>
              <span>Select</span> <strong>Assign CRM</strong><span>, choose</span> <strong>Versafy</strong><span>, and save.</span>
            </li>
          </ol>
        </AlertDescription>
      </Alert>

      <DialogFooter className="sticky bottom-0 z-10 -mx-6 -mb-6 border-t bg-background px-6 py-4">
        <Button asChild type="button" variant="outline">
          <a href={businessSettingsUrl} target="_blank" rel="noreferrer">
            <span>Open Meta Business Settings</span>
            <ExternalLink aria-hidden="true" className="ml-2 h-3.5 w-3.5" />
          </a>
        </Button>
        <Button type="button" onClick={onConfirmed}>
          I Assigned Versafy
        </Button>
      </DialogFooter>
    </div>
  )
}
